import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  callSelectors,
  chatActions,
  chatSelectors,
} from '@lifesize/nucleus';
import ChatConversation from 'components/InCall/InCallChat/InCallChat';
import {
  selectConversationContactDialString,
  setChatMode,
  messageReceived
} from 'actions/Chat';
import {
  bookmarkChatScrollPosition,
  closeInCallDrawer
} from 'actions/InCall/InCallDrawer';
import _isFinite from 'lodash/isFinite';
import _get from 'lodash/get';

function mapStateToProps(state) {
  const activeCall = callSelectors.activeCallSelector(state);
  const isMeeting = activeCall.isMeeting;
  const isFullyConnected = activeCall.callFullyConnected;

  const chatContact = chatSelectors.gqlChatContactForCall(state);
  const conversation = chatSelectors.getChatForWebGenerator(state)(chatContact);

  return {
    activeCall,
    chatContact,
    conversation,
    hasJoinedChat: !!conversation,
    hasNewChat: _get(state, 'app.chat.hasNewChat'),
    isChatLoading: _get(state, 'app.chat.isLoading'),
    isFullyConnected,
    isGettingMessages: _get(state, 'app.chat.isGettingMessages'),
    isMeeting,
    scrollBookmarks: _get(state, 'app.inCallDrawer.chatScrollBookmark')
  };
}


function mapDispatchToProps(dispatch) {
  return {
    onBookmarkScroll: ({ conversationId, lastMessageId, scrollPosition }) => {
      if (conversationId && _isFinite(scrollPosition)) {
        dispatch(
          bookmarkChatScrollPosition(conversationId, {
            lastMessageIdInCall: lastMessageId,
            scrollPositionInCall: scrollPosition
          })
        );
      }
    },
    onGetMoreMessages: (conversation, messageCount = 25) => {
      const contact = _get(conversation, 'contact');
      if (contact) {
        dispatch(
          chatActions.getMoreMessagesForConversation(contact, messageCount)
        );
      }
    },
    joinChat: (contact) => {
      dispatch(setChatMode());
      dispatch(chatActions.enterConversation(contact));
      dispatch(selectConversationContactDialString(contact.dialString));
    },
    enterConversation: (contact) => {
      dispatch(selectConversationContactDialString(contact.dialString));
      dispatch(chatActions.enterConversation(contact));
    },
    markMessagesAsRead: (contact) => {
      dispatch(chatActions.markConversationMessagesAsRead(contact));
    },
    closeDrawer: () => {
      dispatch(closeInCallDrawer());
    },
    // Keeping method name agnostic pending product's decision on scrolling
    // down or having a button to scroll down.
    resetChatFlag: (contact, isVisible) => {
      if (isVisible === true) {
        dispatch(chatActions.markConversationMessagesAsRead(contact));
        dispatch(messageReceived());
      }
    }
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, ownProps, stateProps, dispatchProps, {
    resetChatFlag: () =>
      dispatchProps.resetChatFlag(
        _get(stateProps, 'conversation.contact'),
        ownProps.isVisible
      )
  });

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(ChatConversation)
);
